(function() {
    'use strict';

    angular.module('settings')
        .controller('SettingCreateController', SettingCreateController);

    SettingCreateController.$inject = ['$state', 'settingDataSrvc', 'notificationSrvc', 'settingMessagesConst', 'errorNotificationSrvc'];

    function SettingCreateController($state, settingDataSrvc, notificationSrvc, settingMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name: [],
            value: [],
            description: [],
            nonFieldErrors: []
        };

        self.settingData = {
            name: '',
            value: '',
            description: ''
        };

        self.createSetting = createSetting;
        self.cleanErrors = cleanErrors;

        function createSetting() {
            settingDataSrvc.create(
                self.settingData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", settingMessagesConst.add);
                    $state.go('layout.setting.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
